import type { Common } from '../common.js';
import { APIError } from '../models/common.js';
import { type AnyBlockType } from '../models/flow/flowDefinition.js';
import {
  type BaseBlockTypeMetadata,
  type BlockTypeMetadataFindAllOptions,
  UnknownBlockTypeMetadata,
} from '../models/index.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/block-type-metadata';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(
    queryParams?: BlockTypeMetadataFindAllOptions
  ): Promise<{ blockTypeMetadata: BaseBlockTypeMetadata[] }> {
    const url = this.common.constructPath(`${this.baseEndpoint}`, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneByBlockType(blockType: AnyBlockType): Promise<BaseBlockTypeMetadata> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${blockType}`);
    try {
      return await this.common.getJSON(url);
    } catch (error) {
      if (error instanceof APIError && error.status === 404) {
        return UnknownBlockTypeMetadata;
      }
      throw error;
    }
  }
}
